import { fetchApi } from './api';
import type {
    SuggestRecipientsResponse,
    SendEmailRequest,
    SendEmailResponse,
} from '../types/email';

export const emailApi = {
    suggestRecipients: (itemIds: string[]) => {
        const param = itemIds.length === 1 ? `itemId=${encodeURIComponent(itemIds[0])}` : `itemIds=${encodeURIComponent(itemIds.join(','))}`;
        return fetchApi<SuggestRecipientsResponse>(`/emails/suggest-recipients?${param}`);
    },

    send: (payload: SendEmailRequest) =>
        fetchApi<SendEmailResponse>('/emails/send', {
            method: 'POST',
            body: JSON.stringify(payload),
        }),
};
